import { Outlet } from "react-router-dom";
import MainNavigation from "../components/MainNavigation";
import Footer from "../components/widget/Footer";

function RootLayout(props) {
    return <>
        <MainNavigation isLoggedIn={props.isLoggedIn} onLogout={props.onLogout} />
        <div style={{ margin: "0.5rem" }}>
            <Outlet />
        </div>
        <Footer />
    </>
}

export default RootLayout;